import { API_ENDPOINTS } from "@features/creation/config/constants";
import LdfForm from "@features/creation/ldf/components/LdfForm";
import api from "@lib/api";
import { requirePermission } from "@lib/permissions/guards";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/creation/ldf/$id/edit")({
  loader: requirePermission("creation.ldf.edit"),
  component: EditLdfPage,
});

function EditLdfPage() {
  const { id } = useParams({ from: "/_app/creation/ldf/$id/edit" });
  const { data, isLoading } = useQuery({
    queryKey: ["ldf", id],
    queryFn: () => api.get(API_ENDPOINTS.LDFS.DETAIL(id)).then((r) => r.data),
  });

  if (isLoading) return <div>Chargement...</div>;
  return <LdfForm initialData={data} />;
}
